module.exports = __webpack_public_path__ + "static/media/logo.6a19e282.svg";